/** Shared Cortex/Details field styling, with on-brand orange focus. */
export const CORTEX_FIELD_CLASS =
  "w-full rounded-md border border-grey-200 px-3 py-2 text-sm focus:border-orange-500 focus:ring-2 focus:ring-orange-500/20 focus:outline-none disabled:bg-grey-50 disabled:text-grey-500";

/** As above, with a min height for textareas. */
export const CORTEX_TEXTAREA_CLASS = `min-h-20 ${CORTEX_FIELD_CLASS}`;
